import { useState } from 'react';
import type { UserChangeRoleRequest, ApiResponse } from 'vopay';
import { api } from '@/services/api.config';

export default function useChangeUserRole() {
  const [submitting, setSubmitting] = useState(false);

  async function changeUserRole(params: UserChangeRoleRequest): Promise<ApiResponse> {
    try {
      setSubmitting(true);
      const res = await api.postUserChangeRole(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error('Change user role failed:', error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, changeUserRole };
}
